<template>
  <div
    class="headertip kye-canvas-table-header-popper-wrap"
    ref="headerTip"
    :style="{top: ctop + 'px'}">
    <!-- <div class="gtooltipContent" v-html="content">
    </div> -->
  </div>
</template>

<script>
  import { createPopoverPlugin } from 'public/plugins/popover'
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      top: {
        type: Number,
        default: 0
      },
      left: {
        type: Number,
        default: 0
      },
      content: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        headerTip: null,
        ctop: 0
      }
    },
    watch: {
      show (val) {
        clearTimeout(this._timer)
        if (!val) {
          this.hiddenPopver()
        } else {
          this.popoverInstance.removePopperHandleEvent()
          this.setPosition()
        }
      },
      top (val) {
        this.setPosition()
      },
      left (val) {
        this.setPosition()
      },
      content (val) {
        this.setPosition()
      }
    },
    mounted () {
      this.headerTip = this.$refs.headerTip
      this.createPopover()
    },
    beforeDestroy () {
      this.destroyPopver()
    },
    methods: {
      createPopover () {
        this.popoverInstance = createPopoverPlugin()
        this.popoverInstance.getPopperModalInstance({
          wrapClass: 'kye-canvas-table-header-popper'
        })
      },
      destroyPopver () {
        this.popoverInstance.destroyPopver()
        this.popoverInstance = null
      },
      hiddenPopver () {
        this.popoverInstance.hiddenPopover()
      },
      setPosition () {
        const parent = this.$parent.$refs
        if (!parent.box) return
        this.ctop = this.top
        let w = this.headerTip.offsetWidth
        // let h = this.headerTip.offsetHeight
        let boxW = parent.box.offsetWidth
        let left = Math.min(this.left - w / 2, boxW - w)
        // 考虑最左和最右
        if (this.isLast && (boxW - parent.canvasBox.offsetWidth) < 100) {
          this.headerTip.style.right = '0px'
          this.headerTip.style.left = null
        } else {
          this.headerTip.style.right = null
          this.headerTip.style.left = left <= 0 ? '0px' : left + 'px'
        }
        const vnode = this.$createElement('div', {
          domProps: {
            innerHTML: this.content
          }
        })
        const poppverOptions = {
          width: 'auto',
          placement: 'bottom',
          visibleArrow: true,
          content: vnode,
          isTouchContent: true
        }
        this.popoverInstance.showPoppver(this.headerTip, poppverOptions)
      }
    }
  }
</script>

<style lang="scss">
  .kye-canvas-table-header-popper-wrap {
    position: absolute;
  }
  .kye-canvas-table-header-popper {
    .kye-plugin-popper-wrap-content {
      max-height: none;
    }
  }
  // .headertip {
  //   position: absolute;
  //   z-index: 1000;
  //   border-radius: 4px;
  //   padding: 16px;
  //   min-width: 10px;
  //   max-width: 604px;
  //   word-wrap: break-word;
  //   transform-origin: center bottom 0;
  //   font-size: 12px;
  //   pointer-events: none;
  //   background: #ffffff;
  //   border: 1px solid #e9e8ed;
  //   box-shadow: 0px 2px 6px 0px rgba(211,211,211,0.50);
  // }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-canvas-table/header-tip.vue